export enum OAuthModes {
  LOGIN_REGISTRATION = "login-registration",
  LOGIN_REMINDER = "login-reminder",
  LOGIN_COMPANY_NAME_APPROVER = "login-companyNameApprover",
  LOGIN_NAME_PURCHASE_USE = "login-namePurchaseUse",
  LOGIN_DIRECT_PURCHASE = "login-directPurchase",
  LOGIN_CANCEL_NAME_TITLE_APP = "login-cancelNameTitleApp",
  LOGIN_COMPLAINT = "login-complaint",
  LOGOUT_REGISTRATION = "logout-registration",
  LOGOUT_REMINDER = "logout-reminder",
  LOGOUT_COMPANY_NAME_APPROVER = "logout-companyNameApprover",
  LOGOUT_NAME_PURCHASE_USE = "logout-namePurchaseUse",
  LOGOUT_DIRECT_PURCHASE = "logout-directPurchase",
  LOGOUT_CANCEL_NAME_TITLE_APP = "logout-cancelNameTitleApp",
  LOGOUT_COMPLAINT = "logout-complaint",
}
